import { render, staticRenderFns } from "./DialogNotificationPlayer.vue?vue&type=template&id=65283f10&scoped=true"
import script from "./DialogNotificationPlayer.js?vue&type=script&lang=js&external"
export * from "./DialogNotificationPlayer.js?vue&type=script&lang=js&external"
import style0 from "./DialogNotificationPlayer.vue?vue&type=style&index=0&id=65283f10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65283f10",
  null
  
)

export default component.exports